function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import FullScreenIntroDesktop from './FullScreenIntroDesktop';
import FullScreenIntroMobile from './FullScreenIntroMobile';

class FullScreenIntro extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      fsIntro: FullScreenIntroDesktop
    });

    _defineProperty(this, "handleResize", () => {
      const {
        fsIntro
      } = this.state;
      const {
        trigger
      } = this.props;

      if (window.innerWidth < trigger && fsIntro !== FullScreenIntroMobile) {
        this.setState({
          fsIntro: FullScreenIntroMobile
        });
      }

      if (window.innerWidth >= trigger && fsIntro !== FullScreenIntroDesktop) {
        this.setState({
          fsIntro: FullScreenIntroDesktop
        });
      }
    });
  }

  componentDidMount() {
    const {
      handleResize
    } = this;
    const {
      trigger
    } = this.props;

    if (window.innerWidth < trigger) {
      this.setState({
        fsIntro: FullScreenIntroMobile
      });
    }

    window.addEventListener('resize', handleResize);
  }

  render() {
    const {
      fsIntro
    } = this.state;
    const {
      text,
      image,
      slides,
      styles
    } = this.props;
    const FSIntroType = fsIntro;
    const slider = slides.map(slide => {
      return {
        imageSliderItemImage: [{
          url: slide.image[0].url
        }],
        imageSliderItemUrl: '',
        linkToPage: []
      };
    });
    return (
      /*#__PURE__*/
      React.createElement(FSIntroType, {
        text: text,
        image: image,
        slideshow: slider,
        styles: styles
      })
    );
  }

}

export default FullScreenIntro;